import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import FinishedTasksList from './FinishedTasksList';

export default ColumnsContent(FinishedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/FinishedTasksList/index.js